import React from "react";

import { Space } from "@masterteam/mt-design-react";
import { useIntl, FormattedMessage } from "react-intl";

import Collapse from "../Collapse";
import UpdateKPIActualValues from "./UpdateKPIActualValues";

import { ReactComponent as ChangeKpiActualValuesIcon } from "../../assets/images/change-kpi-actual-values.svg";

import "./style.scss";

const ChangeActualValues = ({
  kpiDetails,
  isReadOnly,
  values,
  errors,
  setFieldValue,
}) => {
  const intl = useIntl();

  return (
    <Collapse
      defaultExpanded
      title={intl.formatMessage({
        id: "change-kpi-actual-values",
      })}
      icon={<ChangeKpiActualValuesIcon fill="none" />}
    >
      <Space direction="vertical" size="large">
        <Space className="section" direction="vertical">
          <Space className="title-wrapper" align="center" size="medium">
            <div className="title">
              <FormattedMessage id="change-request.current-values" />
            </div>
            <hr />
          </Space>

          <Space direction="vertical" size="large" className="body">
            <UpdateKPIActualValues
              values={values}
              kpi={kpiDetails}
              setFieldValue={setFieldValue}
              errors={errors}
              list={kpiDetails?.KPIMeasures}
              isReadOnly
            />
          </Space>
        </Space>

        <Space className="section" direction="vertical">
          <Space
            className="updated-values-title-wrapper"
            align="center"
            size="medium"
          >
            <div className="title ">
              <FormattedMessage id="change-request.values-after-change" />
            </div>
            <hr />
          </Space>

          <Space direction="vertical" size="large" className="body">
            <UpdateKPIActualValues
              values={values}
              kpi={kpiDetails}
              setFieldValue={setFieldValue}
              errors={errors}
              list={values?.KPIMeasures}
              isReadOnly={isReadOnly}
            />
          </Space>
        </Space>
      </Space>
    </Collapse>
  );
};

export default ChangeActualValues;
